// This file is automatically compiled by Webpack, along with any other files
// present in this directory. You're encouraged to place your actual application logic in
// a relevant structure within app/javascript and only use these pack files to reference
// that code so it'll be compiled.

require("@rails/ujs").start()
require("@rails/activestorage").start()

import "@hotwired/turbo-rails"
import "./channels"

// Trix & Action-Text
import "trix"
import "@rails/actiontext"
window.Trix = require("trix")

// Uncomment to copy all static images under ./images to the output folder and reference
// them with the image_pack_tag helper in views (e.g <%= image_pack_tag 'rails.png' %>)
// or the `imagePath` JavaScript helper below.
//
// const images = require.context('./images', true)
// const imagePath = (name) => images(name, true)

//= require local-time

// Allgemein
import LocalTime from "local-time"
LocalTime.start()
import moment from "./packs/moment-with-locales"
window.moment = moment
import "./packs/autoformat"
import "./packs/datepicker"
import "./packs/math-methods"
import "./packs/rangepicker"
import "./packs/trix_customization"
import "./packs/variablen"

// Charts
import "./packs/charts"

// Highcharts Dateien
import "./charts/detailansicht_struktur"
import "./charts/detailansicht_kategorie"
import "./charts/gesamtvermoegen"
import "./charts/highcharts_options"
import "./charts/planungsindexpie"
import "./charts/planungsvergleich"
import "./charts/planungssimulations"
import "./charts/planungssimulations_liqui"
import "./charts/verbindlichkeiten"
import "./charts/vermoegensaufteilung_mandant"
import "./charts/vermoegensaufteilung_partner"
import "./charts/bav"

import "./charts/vermoegensstruktur"
import "./charts/liquiditaetsverlauf"

// Organisation
import "./packs/users"
import "./packs/registrierung"

// Planung
import "./packs/buz_beitragsbefreiungs"
import "./packs/jahre_ohne_steigerung"
import "./packs/liquidierungs"
import "./packs/planungs"
import "./packs/planung_kinds"
import "./packs/vermoegenswert_anlageklasse"

// Notizen/Aufgaben
import "./packs/aufgabenfilter"
import "./packs/aufgabes"

// Vermoegenswerte/Charts
import "./vermoegenswerte/anleihe"
import "./vermoegenswerte/basisrente_fond"
import "./vermoegenswerte/basisrente_klassik"
import "./vermoegenswerte/buversicherung"
import "./vermoegenswerte/buz"
import "./vermoegenswerte/festgeld"
import "./vermoegenswerte/gkv"
import "./vermoegenswerte/grv"
import "./vermoegenswerte/immobilie"
import "./vermoegenswerte/pkv"
import "./vermoegenswerte/rentenversicherung_fond"
import "./vermoegenswerte/rentenversicherung_klassik"
import "./vermoegenswerte/risikolebensversicherung"
import "./vermoegenswerte/sachversicherung"
import "./vermoegenswerte/sonstiger_vermoegenswert"
import "./vermoegenswerte/todesfallschutz"
import "./vermoegenswerte/unternehmen"
import "./vermoegenswerte/vermoegensverlauf"
import "./vermoegenswerte/zusatzversicherung"
import "./vermoegenswerte/zusatzversorgung"
import "./controllers"

// Neue Turbo-Stream-Action redirect
Turbo.StreamActions.redirect_to = function () {
	const url = this.getAttribute("url") || "/"
	Turbo.visit(url)
}
